import React, {useEffect,useState} from 'react';
import styles from './HomeContetn.module.scss'
import ImgReact from './img/react.png'
import ImgJS from './img/js.png'
import Photo from './img/IMG_29302.png'
import {Link} from "react-router-dom";

const HomeContent = (props) => {
    const [x,setX]= useState(0)
    useEffect(()=>{

       const interv = setInterval(()=>{
            setX((xx)=>{
                return xx+0.5
            })
        },10)
        return ()=>{
           clearInterval(interv)
        }
    },[])

    return (
        <div className={styles.HomeContent}>
            <div className={styles.HomeContent_left}>
                <div className={styles.discription}>
                    <div className={styles.titles}>
                        <h1>Всем привет, меня зовут Александр</h1>
                        <h3>Шумигин Александр 27 лет , Front-End разработчик</h3>
                    </div>
                    <h4>Занимаюсь разработкой Web приложений, сайтов , с помощью: </h4>
                </div>
                <div className={styles.images}>
                    <div>
                        <span className={styles.React_title}>React</span>
                        <img style={{transform:`rotate(${x}deg)`}} src={ImgReact} alt=""/>
                    </div>
                    <div>
                        <span className={styles.JS_title}>JavaScript</span>
                        <img src={ImgJS} alt=""/>
                    </div>
                </div>
                <div className={styles.contact}>
                    <div className={styles.contact_title_item}>
                        <div className={styles.contact_title}>
                            <span>Контакты</span>
                        </div>
                        <div className={styles.contact_items}>
                            <div>
                                <span>E-mail :</span>
                                <span>Skype :</span>
                                <span>Viber :</span>
                                <span>WhatsApp :</span>
                                <span>Telegram :</span>
                            </div>
                            <div className={styles.contact_items_right}>
                                <span>conter10@mail.ru</span>
                                <span>pioner923</span>
                                <span>+48576116436</span>
                                <span>+34698779553</span>
                                <span>+34688779553</span>
                            </div>

                        </div>
                    </div>
                    <div >
                        <Link to='/portfolio'><span className={styles.contact_button}>Мои Работы</span></Link>
                    </div>
                </div>
            </div>
            <div className={styles.HomeContent_right}>
                <img src={Photo} alt=""/>
            </div>
        </div>
    );
};

export default HomeContent;